import { Box } from '@mui/material';
import React from 'react';
import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
} from 'chart.js';
import { classes } from './utils';
import 'chartjs-plugin-style';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
);
const LineChart = ({ months, scans }) => {
  const data = {
    labels: months ? months.map((month) => month.substring(0, 3)) : [],
    datasets: [
      {
        label: 'Sales',
        data: scans || [],
        backgroundColor: 'rgba(159, 119, 235, 1)',
        borderColor: 'rgba(159, 119, 235, 1)',
        borderWidth: 3,

        pointRadius: 0,
        pointHoverRadius: 6,
        pointHitRadius: 10,
        lineTension: 0.35,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      tooltip: {
        display: true,
        enabled: true,
        displayColors: false,

        backgroundColor: 'rgba(255, 255, 255, 1)',
        padding: 15,
        titleAlign: 'center',
        titleColor: 'rgba(0, 0, 0, 1)',
        titleFont: { weight: '500', family: 'Heebo' },
        bodyAlign: 'center',
        bodyColor: 'rgba(0, 0, 0, 0.6)',
        bodyFont: { weight: '400', family: 'Heebo' },
        caretSize: 7,
        yAlign: 'bottom',
        borderWidth: 5,
      },
    },

    scales: {
      x: {
        display: true,
        border: {
          display: false,
          dash: [2, 2],
        },
        grid: {
          display: true,
          color: 'rgba(0, 0, 0, 0.14)',
          lineWidth: 1,
          drawTicks: false,
          drawBorder: true,
          drawOnChartArea: true,
        },
        title: {
          display: true,
          text: 'Plan Duration',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            top: 30,
          },
        },
        ticks: {
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
      },
      y: {
        display: true,
        border: {
          display: false,
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: 'No of Scan',
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
          padding: {
            bottom: 20,
          },
        },
        max: 200,
        min: 0,
        ticks: {
          stepSize: 50,
          color: 'rgba(43, 43, 43, 0.4)',
          font: { size: '15px', weight: '400', family: 'Heebo' },
        },
        offset: true,
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };

  return (
    <Box className={classes.scanHistoryLineChart}>
      <Line
        data={data}
        options={options}
        style={{
          height: '100%',
          width: '100%',
        }}
      />
    </Box>
  );
};

LineChart.propTypes = {
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  scans: PropTypes.arrayOf(PropTypes.number).isRequired,
};
export default LineChart;
